<template>
    <div>
        <loading :active.sync="is_loading" 
        :can-cancel="false" 
        :is-full-page="true"></loading>
        <Navbar />
        <div class="container-fluid">
            <SidebarSarpras/>
            <main class="main" id="main">
                <Breadcrumb :links="[{url: '/dashboard', text:'Home'}, {url: '#', text: 'Riwayat Inspeksi Sarana dan Prasana'}, {url: '#', text: 'Tambah'}]"/>
                <h2><b>Tambah Inspeksi</b></h2>
                <div class="card">
                    <div class="card-body">
                        <div class="form-group mb-3">
                            <label for="">Nomor Aset</label>
                            <input type="text" class="form-control" disabled v-model="structure.nomor_aset">
                        </div>
                        <div class="form-group mb-3">
                            <label for="">Nama Objek</label>
                            <input type="text" class="form-control" disabled v-model="structure.nama_objek">
                        </div>
                        <template v-if="structure.structure_type_id === 1">
                            <div class="form-group mb-3">
                                <label for="">Jenis Tanah</label>
                                <input type="text" class="form-control" disabled v-model="structure.land_type.name">
                            </div>
                            <div class="form-group mb-3">
                                <label for="">Jenis Aset</label>
                                <input type="text" class="form-control" disabled v-model="structure.asset_type.name">
                            </div>
                        </template>
                        <template v-else>
                            <div class="row">
                                <div class="col-md-6 col-12">
                                    <div class="form-group mb-3">
                                        <label for="">Jenis Bangunan</label>
                                        <input type="text" class="form-control" disabled v-model="structure.building_type.name">
                                    </div>
                                </div>
                                <div class="col-md-6 col-12">
                                    <div class="form-group mb-3">
                                        <label for="">Jenis Aset</label>
                                        <input type="text" class="form-control" disabled v-model="structure.building_category.name">
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div class="row">
                            <div class="col-md-6 col-12">
                                <div class="form-group mb-3">
                                    <label for="">Unit Kerja</label>
                                    <input type="text" class="form-control" disabled v-model="structure.work_unit.name">
                                </div>
                            </div>
                            <div class="col-md-6 col-12">
                                <div class="form-group mb-3">
                                    <label for="">Seksi</label>
                                    <input type="text" class="form-control" disabled v-model="structure.section.name">
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-3 col-12">
                                <div class="form-group">
                                    <label for="inspection_date">Tanggal Inspeksi</label>
                                    <input 
                                        type="date" 
                                        id="inspection_date"
                                        class="form-control" 
                                        v-model="inspection_date"
                                        required
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-2 col-12">
                                <div class="form-group">
                                    <label for="">Kondisi Fungsi</label>
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="kondisi_fungsi">
                                        <span class="input-group-text">%</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2 col-12">
                                <div class="form-group">
                                    <label for="">Kondisi Fisik</label>
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="kondisi_fisik">
                                        <span class="input-group-text">%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group mb-3">
                            <label for="">Penjelasan Kondisi</label>
                            <textarea v-model="penjelasan_kondisi" class="form-control"></textarea>
                        </div>
                        <div class="form-group mb-3">
                            <label for="">Riwayat Perbaikan</label>
                            <textarea v-model="riwayat_perbaikan" class="form-control"></textarea>
                        </div>
                        <div class="form-group mb-3">
                            <label for="">Layanan di Hilir Prasarana</label>
                            <input type="text" class="form-control" v-model="layanan_hilir">
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-3 col-12">
                                <div class="form-group">
                                    <label for="">Perkiraan Biaya Kerugian</label>
                                    <div class="input-group">
                                        <span class="input-group-text">Rp</span>
                                        <input type="text" class="form-control" v-model="formatted_biaya_kerugian">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 col-12">
                                <div class="form-group">
                                    <label for="">Perkiraan Biaya Perbaikan</label>
                                    <div class="input-group">
                                        <span class="input-group-text">Rp</span>
                                        <input type="text" class="form-control" v-model="formatted_biaya_perbaikan">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group mb-3">
                            <label for="inspection_images">Foto Inspeksi</label>
                            <input
                                id="inspection_images"
                                type="file"
                                class="form-control"
                                accept="image/*"
                                multiple
                                :disabled="is_uploading_images"
                                @change="handleImageUpload"
                            >
                            <small class="text-muted" v-if="is_uploading_images">Sedang mengunggah foto...</small>
                        </div>
                        <div v-if="inspection_images.length > 0" class="row g-3 mb-3">
                            <div v-for="(image, index) in inspection_images" :key="image.id || image.url || index" class="col-md-3 col-sm-4 col-6">
                                <div class="inspection-image-card">
                                    <button type="button" class="btn btn-danger btn-sm inspection-image-delete" @click="removeImage(index)" :disabled="image.isDeleting">
                                        <i class="fa fa-times"></i>
                                    </button>
                                    <img :src="image.preview" class="img-fluid inspection-image-preview" :alt="image.name || `Foto ${index + 1}`">
                                </div>
                            </div>
                        </div>
                        <div class="form-group mb-3">
                            <label for="">Skala Prioritas</label><br>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="skala" id="inlineRadio1" value="1" v-model="skala_prioritas">
                                <label class="form-check-label" for="inlineRadio1">Segera</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="skala" id="inlineRadio2" value="2" v-model="skala_prioritas">
                                <label class="form-check-label" for="inlineRadio2">Perlu</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="skala" id="inlineRadio3" value="3" v-model="skala_prioritas">
                                <label class="form-check-label" for="inlineRadio3">Dapat ditangguhkan</label>
                            </div>
                        </div>
                        <hr>
                        <button class="btn btn-primary me-2" @click="create"><i class="fa fa-save"></i> Simpan</button>
                        <router-link :to="{name: 'InspectionIndex', params: { id: $route.params.id }}" class="btn btn-danger"><i class="fa fa-times"></i> Batal</router-link>
                    </div>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
import Navbar from '../../../components/Navbar.vue'
import Breadcrumb from '../../../components/Breadcrumb.vue'
import Loading from 'vue-loading-overlay';
import moment from 'moment';
import 'vue-loading-overlay/dist/vue-loading.css'
import SidebarSarpras from '../../../components/SidebarSarpras.vue'
import axios from 'axios'
import { quillEditor } from 'vue-quill-editor'

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
 

export default {
    components: {
        Navbar,
        Loading,
        Breadcrumb,
        SidebarSarpras,
        quillEditor
    },
    computed: {
        formatted_biaya_kerugian: {
            get() {
                return this.formatCurrency(this.biaya_kerugian);
            },
            set(value) {
                this.biaya_kerugian = this.parseCurrency(value);
            }
        },
        formatted_biaya_perbaikan: {
            get() {
                return this.formatCurrency(this.biaya_perbaikan);
            },
            set(value) {
                this.biaya_perbaikan = this.parseCurrency(value);
            }
        }
    },
    data(){
        return {
            is_loading: false,
            structure: {
                land_type: {},
                asset_type: {},
                building_type: {},
                building_category: {},
                work_unit: {},
                section: {}
            },
            inspection_date: moment().format('YYYY-MM-DD'),
            penjelasan_kondisi: "",
            riwayat_perbaikan: "",
            layanan_hilir: "",
            kondisi_fisik: null,
            kondisi_fungsi: null,
            biaya_kerugian: null,
            biaya_perbaikan: null,
            skala_prioritas: null,
            inspection_images: [],
            is_uploading_images: false
        }
    },
    methods: {
        formatCurrency(value) {
            if (value === null || value === undefined || value === '') {
                return '';
            }

            return new Intl.NumberFormat('id-ID').format(Number(value));
        },
        parseCurrency(value) {
            const numericValue = String(value || '').replace(/\D/g, '');
            return numericValue === '' ? null : numericValue;
        },
        normalizeImagePayload(uploadResponse, file) {
            if (typeof uploadResponse === 'string') {
                return {
                    id: null,
                    name: file.name,
                    url: uploadResponse,
                    preview: uploadResponse
                };
            }

            const payload = uploadResponse && typeof uploadResponse === 'object'
                ? (uploadResponse.data && typeof uploadResponse.data === 'object' ? uploadResponse.data : uploadResponse)
                : {};

            const url = payload.url || payload.path || payload.file_url || payload.location || payload.filename || payload.file;

            return {
                id: payload.id || null,
                name: payload.original_name || payload.name || file.name,
                url,
                filename: payload.filename || null,
                preview: payload.preview || url
            };
        },
        async handleImageUpload(event) {
            const files = Array.from(event.target.files || []);

            if (files.length === 0) {
                return;
            }

            this.is_uploading_images = true;

            try {
                const uploadedImages = [];

                for (const file of files) {
                    const formData = new FormData();
                    formData.append('file', file);

                    const response = await axios.post(`${this.$endpoints.sarpras}/upload`, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });

                    const normalizedImage = this.normalizeImagePayload(response.data, file);

                    if (!normalizedImage.url) {
                        throw new Error('Invalid upload response');
                    }

                    uploadedImages.push(normalizedImage);
                }

                this.inspection_images = [...this.inspection_images, ...uploadedImages];
                event.target.value = '';
            } catch (error) {
                this.$swal('Gagal', 'Upload foto gagal, silakan coba lagi.', 'error');
            } finally {
                this.is_uploading_images = false;
            }
        },
        getImageFilename(image) {
            if (image.filename) {
                return image.filename;
            }

            const source = image.url || image.preview || '';

            if (!source) {
                return null;
            }

            const normalizedSource = source.split('?')[0];
            const segments = normalizedSource.split('/').filter(Boolean);
            const filename = segments.length > 0 ? segments[segments.length - 1] : null;

            return filename ? decodeURIComponent(filename) : null;
        },
        async removeImage(index) {
            const image = this.inspection_images[index];
            const filename = this.getImageFilename(image);

            if (!filename) {
                this.$swal('Gagal', 'Filename foto tidak ditemukan.', 'error');
                return;
            }

            this.$set(this.inspection_images[index], 'isDeleting', true);

            try {
                await axios.delete(`${this.$endpoints.sarpras}/upload/${encodeURIComponent(filename)}`);
                this.inspection_images.splice(index, 1);
            } catch (error) {
                this.$swal('Gagal', 'Foto gagal dihapus dari server.', 'error');
            } finally {
                if (this.inspection_images[index]) {
                    this.$set(this.inspection_images[index], 'isDeleting', false);
                }
            }
        },
        create(){
            if (this.is_uploading_images) {
                this.$swal('Mohon tunggu', 'Upload foto masih berjalan.', 'warning');
                return;
            }

            this.is_loading = true;
            const user = localStorage.getItem('name');
            const user_id = localStorage.getItem('id');
            const { id } = this.$route.params;

            axios.post(`${this.$endpoints.sarpras}/inspections`, {
                structure_id: id,
                inspection_date: this.inspection_date,
                kondisi_fungsi: this.kondisi_fungsi,
                kondisi_fisik: this.kondisi_fisik,
                penjelasan_kondisi: this.penjelasan_kondisi,
                riwayat_perbaikan: this.riwayat_perbaikan,
                layanan_hilir: this.layanan_hilir,
                biaya_kerugian: this.biaya_kerugian,
                biaya_perbaikan: this.biaya_perbaikan,
                skala_prioritas: this.skala_prioritas,
                photo: this.inspection_images.map(image => image.url),
                user,
                user_id
            })
            .then(() => {
                this.$swal('Berhasil', 'Data inspeksi berhasil ditambahkan', 'success');

                this.$router.push({name: 'InspectionIndex', params: {id}})
            })
            .catch(() => {
                this.$swal('Gagal', 'Data inspeksi gagal ditambahkan', 'error');
            })
            .finally(() => {
                this.is_loading = false;
            });
        }
    },
    mounted(){
        axios.get(`${this.$endpoints.sarpras}/structures/${this.$route.params.id}`)
        .then(response => {
            this.structure = response.data;
        })
    }
}
</script>

<style scoped>
.inspection-image-card {
    position: relative;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 8px;
    background: #fff;
}

.inspection-image-preview {
    width: 100%;
    height: 180px;
    object-fit: cover;
    border-radius: 6px;
}

.inspection-image-delete {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 1;
    width: 30px;
    height: 30px;
    padding: 0;
    border-radius: 50%;
}
</style>
